import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const Prefix = "ButtonBox";
export const classes = {
  root: `${Prefix}-root`,
  list: `${Prefix}-list`,
  listButton: `${Prefix}-listButton`,
};

export const ButtonBox = styled(Box)(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: "48px",
    height: "40px",
    overflow: "hidden",
    border: "2px solid",
    borderColor: theme.palette.primary.main,
    backgroundColor: "white",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.12)",
    "& .MuiButtonBase-root": {
      width: "48px",
      height: "40px",
      border: "none",
    },
    "& .MuiButton-icon": {
      margin: 0,
    },
  },
}));
